import React from 'react'
import { connectStore } from "redux-box";
import { module as passages } from "@st/passages";
import { module as ui } from "@st/ui";
import './PassagesDetailsModal.css'

const PassagesDetailsModal = (props) => {
    return (
        <div className='passage_details_container'>
            <h5>{props.passages && props.passages.active_passage && props.passages.active_passage.title}</h5>
            <p>{props.passages.active_passage.content}</p>
        </div>
    )
}

export default connectStore({ passages, ui })(PassagesDetailsModal);
